export default {
  people: [
    {
      name: 'Tim Chen',
      firstName: 'Tim',
      title: 'Chief Executive Officer',
      blurb:
        'Tim started NerdWallet after realizing there is a lack of trustworthy financial advice available to consumers.',
      description:
        "In 2009, Tim and co-founder Jake Gibson started NerdWallet with a goal to bring clarity to all of life's financial decisions. Since then, he's been busy as CEO of NerdWallet, helping inspire our Nerds to bring clarity to personal finance.\n\n\"NerdWallet is on a mission shared by a dedicated group of Nerds. The idea of a world where everyone is empowered to make financial decisions with confidence transcends any individual, permeating the entire organization's values.\"",
      image: '/images/executives/tim_lg.jpg',
      imageMobile: '/images/executives/tim_sm.jpg',
      imageAlt: 'Tim Chen',
      linkedInLink: 'https://www.linkedin.com/in/tim-chen-1722b9/',
    },
    {
      name: 'Lauren StClair',
      firstName: 'Lauren',
      title: 'Chief Financial Officer',
      blurb:
        "With over 18 years of experience in finance, Lauren leads NerdWallet's financial operations with a focus on expanding domestic and international growth.",
      description:
        'Lauren brings 18+ years of finance experience for both startups and multinational corporations. Prior to joining NerdWallet, she was the CFO of North America at eBay, and CFO at StubHub International in Spain. Lauren has a B.S. degree from Stanford University and an M.B.A. from Duke University.\n\n"I am constantly amazed at the discipline we have instilled across the NerdWallet organization. We are thoughtful about our investments yet comfortable taking informed risks to push the boundaries and deliver the best for our customers."',
      image: '/images/executives/lauren_lg.jpg',
      imageMobile: '/images/executives/lauren_sm.jpg',
      imageAlt: 'Lauren StClair',
      linkedInLink: 'https://www.linkedin.com/in/lauren-stclair-waugh-a305ab8/',
    },
    {
      name: 'Kevin Yuann',
      firstName: 'Kevin',
      title: 'Chief Business Officer',
      blurb:
        'Kevin focuses on driving growth in our businesses. He leads our General Managers, Business Development, BizOps, and Corporate Development teams.',
      description:
        'Before joining NerdWallet, Kevin managed strategy and operations teams at Visa and Deloitte Consulting. He has an M.B.A. from UCLA and a B.A. from Brown University.\n\n"Winning together as a team is more fulfilling than doing it alone."',
      image: '/images/executives/kevin_lg.jpg',
      imageMobile: '/images/executives/kevin_sm.jpg',
      imageAlt: 'Kevin Yuann',
      linkedInLink: 'https://www.linkedin.com/in/kevinyuann/',
    },
    {
      name: 'Ekumene "E" Lysonge',
      firstName: '"E"',
      title: 'General Counsel',
      blurb:
        'E joins NerdWallet with 20+ years of experience leading legal functions in the gaming, entertainment, eCommerce, technology, and real estate sectors.',
      description:
        'E\'s experience as a corporate generalist spans multiple subject matters, including, but not limited to, corporate governance, securities, data privacy, technology and intellectual property, regulatory and government affairs, mergers and acquisitions, real estate, and property management.\n\n"At NerdWallet, we always aim to lead from the front, whether by utilizing our cutting-edge data analytics, research, and content publishing platforms, or using our voice to encourage private industry to take a stand socially and invest dollars in the communities most in need."',
      image: '/images/executives/e_lg.jpg',
      imageMobile: '/images/executives/e_sm.jpg',
      imageAlt: 'Ekumene Lysonge',
      linkedInLink: 'https://www.linkedin.com/in/ekumenelysonge',
    },
    {
      name: 'Lynee Luque',
      firstName: 'Lynee',
      title: 'Chief People Officer',
      blurb:
        'Lynee enjoys scaling culture within organizations and creating end-to-end employee programs that support growth and change.',
      description:
        'Lynee brings 20+ years of professional experience, 15 as an HR professional and 6 in Advisory Services. This blend of experience ensures we not only build people and cultural programs that scale but also sets us up to support business growth. Prior to joining NerdWallet, Lynee was VP and Head of People at Envoy and Global Human Resources Director for Twitter. Lynee has a B.S. degree from UC Berkeley and an M.B.A. from University of Michigan, Ann Arbor.\n\n"We\'re building an organization where every Nerd has an opportunity to grow personally and professionally."',
      image: '/images/executives/lynee_lg.jpg',
      imageMobile: '/images/executives/lynee_sm.jpg',
      imageAlt: 'Lynee Luque',
      linkedInLink: 'https://www.linkedin.com/in/lynee-luque-b739541/',
    },
    {
      name: 'Hanah Cho',
      firstName: 'Hanah',
      title: 'VP, Content',
      blurb:
        'Hanah is an award-winning financial journalist who helps NerdWallet create content that makes complex financial decisions easier to understand so consumers can lead richer lives.',
      description:
        'Hanah started her career in journalism almost 20 years ago and has worked as a writer for The Associated Press, The Los Angeles Times, The Baltimore Sun, and The Dallas Morning News. Her specialties include mutual funds, energy issues, small businesses, entrepreneurs, and workplace trends. She has a B.A. in English and Political Science from Rutgers University and a Masters in Journalism from the University of Maryland.\n\n"NerdWallet cultivates a rare combination of collaborative and open, candid, and constructive culture that allows Nerds to develop and thrive as leaders."',
      image: '/images/executives/hanah_lg.jpg',
      imageMobile: '/images/executives/hanah_sm.jpg',
      imageAlt: 'Hanah Cho',
      linkedInLink: 'https://www.linkedin.com/in/hanahcho',
    },
  ],
};
